import { REDBALL_INACTIVE_ACCOUNT_CONSTANTS } from "../../constants/StringConstants";

export const CountryCode = [
  {
    countryName: "Australia",
    regionId: "36",
    ccode: "AU",
    langCode: "en",
  },
  {
    countryName: "New Zealand",
    regionId: "554",
    ccode: "NZ",
    langCode: "en",
  },
  {
    countryName: "Ireland",
    regionId: "372",
    ccode: "IE",
    langCode: "en",
  },
  {
    countryName: "France",
    regionId: "250",
    ccode: "FR",
    langCode: "fr",
  },
  {
    countryName: "Germany",
    regionId: "276",
    ccode: "DE",
    langCode: "de",
  },
  {
    countryName: "Netherlands",
    regionId: "528",
    ccode: "NL",
    langCode: "nl",
  },
  {
    countryName: "United Kingdom",
    regionId: "826",
    ccode: "GB",
    langCode: "en",
  },
  {
    countryName: "US",
    regionId: "840",
    ccode: "US",
    langCode: "en",
  },
  {
    countryName: "Canada",
    regionId: "124",
    ccode: "CA",
    langCode: "en",
  },
  {
    countryName: "Austria",
    regionId: "40",
    ccode: "AT",
    langCode: "de",
  },
  {
    countryName: "Belgium",
    regionId: "56",
    ccode: "BE",
    langCode: "nl",
  },
  {
    countryName: "Italy",
    regionId: "380",
    ccode: "IT",
    langCode: "it",
  },
  {
    countryName: "Poland",
    regionId: "616",
    ccode: "PL",
    langCode: "pl",
  },
  {
    countryName: "Portugal",
    regionId: "620",
    ccode: "PT",
    langCode: "pt",
  },
  {
    countryName: "Spain",
    regionId: "724",
    ccode: "ES",
    langCode: "es",
  },
  // {
  //     countryName: "Chile",
  //     regionId: "",
  //     ccode: "CL",
  //     langCode: "en"
  // },
  // {
  //     countryName: "Switzerland",
  //     regionId: "",
  //     ccode: "CH",
  //     langCode: "en"
  // }
];

export const NON_ERP_COUNTRY_LIST = [
  { country: "Italy", countryCode: "ITA" },
  { country: "Poland", countryCode: "POL" },
  { country: "Portugal", countryCode: "PRT" },
  { country: "Spain", countryCode: "ESP" },
];

export const NA_COUNTRY = ["840", "124"];

export const APAC_COUNTRY = ["36", "554"];

export const EMEA_COUNTRY = ["250", "276", "372", "528", "826", "40", "56"];

// Below initialized variables are only applicable for getCountryContact() method
const APAC_EMAIL = "accountsaus@verizonconnect.com";
const GER_AUSTRIA_EMAIL = "mahnwesen@verizonconnect.com";
const NED_BEL_EMAIL = "accountseu@verizonconnect.com";
const NA_PHONE = "1-800-283-9801";
const FRA_ACC_HOLDER = "Verizon Connect France";
const FRA_IBAN = "FR76 4121 9160 1000 0330 4601 988";
const FRA_SWIFTBIC = "BOFAFRPP";
const NED_ACC_HOLDER = "Verizon Connect Netherlands";
const NED_IBAN = "NL97BOFA0266509940";
const NED_SWIFTBIC = "BOFANLNX";
const GER_AUSTRIA_PHONE = REDBALL_INACTIVE_ACCOUNT_CONSTANTS.CONTACT_NUMBER_GERMANY;
const NED_BEL_PHONE = REDBALL_INACTIVE_ACCOUNT_CONSTANTS.CONTACT_NUMBER_NETHERLANDS;

export const getCountryContact = (regionId) => {
  const regionContactMap = {
    36: { email: APAC_EMAIL, phone: "1-800-039-642" },
    554: { email: APAC_EMAIL, phone: "0508 761 181" },
    372: { email: "accountseu@verizonconnect.com", phone: REDBALL_INACTIVE_ACCOUNT_CONSTANTS.CONTACT_NUMBER_IRELAND },
    250: { email: "recouvrement@verizonconnect.com", phone: REDBALL_INACTIVE_ACCOUNT_CONSTANTS.CONTACT_NUMBER_FRANCE },
    276: { email: GER_AUSTRIA_EMAIL, phone: GER_AUSTRIA_PHONE },
    528: { email: NED_BEL_EMAIL, phone: NED_BEL_PHONE },
    826: { email: "accountseu@verizonconnect.com", phone: REDBALL_INACTIVE_ACCOUNT_CONSTANTS.CONTACT_NUMBER_UK },
    40: { email: GER_AUSTRIA_EMAIL, phone: GER_AUSTRIA_PHONE },
    56: { email: NED_BEL_EMAIL, phone: NED_BEL_PHONE },
    840: { email: "", phone: NA_PHONE },
    124: { email: "", phone: NA_PHONE },
  };

  let countryContactMapper = regionContactMap[regionId] || { email: "", phone: NA_PHONE };
  countryContactMapper.regionId = regionId || "840";

  return countryContactMapper;
};

export const getBankDetails = (regionId) => {
  const regionBankDetailsMap = {
    372: { accHolder: "Verizon Connect Ireland", IBAN: "IE98 BOFA 9900 6157 9210 11", SWIFTBIC: "BOFAIE3X" },
    250: { accHolder: FRA_ACC_HOLDER, IBAN: FRA_IBAN, SWIFTBIC: FRA_SWIFTBIC },
    276: { accHolder: "Verizon Connect Germany", IBAN: "DE92 5001 0900 0021 0080 14", SWIFTBIC: "BOFADEFX" },
    528: { accHolder: NED_ACC_HOLDER, IBAN: NED_IBAN, SWIFTBIC: NED_SWIFTBIC },
    826: {
      accHolder: "Verizon Connect UK Limited",
      IBAN: "GB49 BOFA 1650 5079 9750 10",
      SWIFTBIC: "BOFAGB22",
      sortCode: "30-16-35",
      accNumber: "79975010",
    },
    40: { accHolder: FRA_ACC_HOLDER, IBAN: FRA_IBAN, SWIFTBIC: FRA_SWIFTBIC },
    56: { accHolder: NED_ACC_HOLDER, IBAN: NED_IBAN, SWIFTBIC: NED_SWIFTBIC },
  };

  const defaultBankDetails = {
    accHolder: "",
    IBAN: "",
    SWIFTBIC: "",
    sortCode: "",
    accNumber: "",
  };

  let bankDetailsMapper = regionBankDetailsMap[regionId] || defaultBankDetails;
  bankDetailsMapper.regionId = regionId || "";

  return bankDetailsMapper;
};
